import R from 'ramda';

export default function queryParamsMiddleware(history, options = {}) {
  const metaKey = options.metaKey || 'queryParams';

  return (/* store */) => next => action => {
    const querySpec = action.meta && action.meta[metaKey];

    if (querySpec && !action.meta.skipQueryUpdate) {
      const location = history.getCurrentLocation();
      const historyAction = action.meta.replaceQueryParams ? 'replace' : 'push';
      const pathname = action.meta.pathname || location.pathname;

      if (action.meta.mergeQueryParams) {
        history[historyAction]({
          pathname,
          query: R.pickBy(value => !R.isNil(value), {
            ...history.getCurrentLocation().query,
            ...querySpec,
          }),
        });
      } else {
        history[historyAction]({
          pathname,
          query: querySpec,
        });
      }
    }

    next(action);
  };
}
